import { Inject, Injectable, Optional } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { removeRouterOutletsFromUrl } from '@vendasta/shared';
import { GALAXY_PAGE_OPTIONS, GalaxyPageOptions } from './tokens';

@Injectable({ providedIn: 'root' })
export class PageService {
  private readonly history: (string | null)[];

  showNavToggle = false;

  constructor(
    private router: Router,
    @Optional() @Inject(GALAXY_PAGE_OPTIONS) private pageOptions: GalaxyPageOptions | undefined,
  ) {
    this.history = [router.url];
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        while (this.history.length > 0 && this.history[this.history.length - 1] === null) {
          this.history.pop();
        }
        if (this.router.getCurrentNavigation()?.extras?.skipLocationChange) {
          this.history.push(null);
        } else if (this.history.length === 0 || event.url !== this.history[this.history.length - 1]) {
          const previousUrl = this.history[this.history.length - 1];
          const previousUrlPath = previousUrl?.substring(
            0,
            previousUrl?.indexOf('?') > 0 ? previousUrl?.indexOf('?') : undefined,
          );
          const activeUrl = event.urlAfterRedirects;
          const activeUrlPath = activeUrl?.substring(
            0,
            activeUrl?.indexOf('?') > 0 ? activeUrl?.indexOf('?') : undefined,
          );

          if (previousUrl && previousUrlPath === activeUrlPath) {
            this.history.pop(); // remove the previous url if it is the same as the current url's path without query params
          }
          this.history.push(activeUrl);
        }
      }
    });

    this.showNavToggle = this.pageOptions?.showToggle || false;
  }

  getPreviousPageUrl(defaultUrl: string): string {
    if (this.history.length > 1) {
      const previousUrl = this.history[this.history.length - 2];
      // This is to remove any router outlets from the previous url
      return previousUrl ? removeRouterOutletsFromUrl(previousUrl) : '';
    }

    return defaultUrl;
  }

  pop(deleteCount = 2): void {
    this.history.splice(-deleteCount, deleteCount);
  }
}
